import imageUtilities from "../../../utilities/imageUtilities"
import { CashlessProviderCodesInput } from "./cashlessProviderCodesInput"
export const FormSitePaymentProviders = ({ parkonomySiteCode, setParkonomySiteCode, ringGoZone, setRingGoZone, parkBunnyLocationId, setParkBunnyLocationId, justParkLocationId, setJustParkLocationId, tap2ParkLocationId, setTap2ParkLocationId, payByPhoneLocationId, setPayByPhoneLocationId, ipsLocationId, setIpsLocationId, conviousLocationId, setConviousLocationId, lookingForCarParkLocationId, setLookingForCarParkLocationId, newParkLocationId, setNewParkLocationId, parksoLocationId, setParksoLocationId, myCarPassLocationId, setMyCarPassLocationId }) => {
    return (
        <>
            <hr className="border-dashed border-bottom-0"></hr>
            <h6 className="mb-3 fs-1">Payment Provider Site Codes</h6>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(1) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="text" value={ parkonomySiteCode } onChange={ (e) => setParkonomySiteCode(e.target.value) } />
                    </div>
                </div>
            </div>

            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(2) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput 
                        allCodes={ringGoZone}
                        handleSubmit={updatedCodes => setRingGoZone(updatedCodes)}
                    />
                </div>
            </div>

            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(7) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={parkBunnyLocationId}
                        handleSubmit={updatedCodes => setParkBunnyLocationId(updatedCodes)}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(4) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={justParkLocationId}
                        handleSubmit={updatedCodes => setJustParkLocationId(updatedCodes)}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(5) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={tap2ParkLocationId}
                        handleSubmit={updatedCodes => setTap2ParkLocationId(updatedCodes)}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(6) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={payByPhoneLocationId}
                        handleSubmit={updatedCodes => setPayByPhoneLocationId(updatedCodes)}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(8) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={ipsLocationId}
                        handleSubmit={updatedCodes => setIpsLocationId(updatedCodes)}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(9) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={conviousLocationId}
                        handleSubmit={updatedCodes => setConviousLocationId(updatedCodes)}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(10) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={lookingForCarParkLocationId}
                        handleSubmit={updatedCodes => setLookingForCarParkLocationId(updatedCodes)}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(11) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={newParkLocationId}
                        handleSubmit={updatedCodes => setNewParkLocationId(updatedCodes)}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(12) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={parksoLocationId}
                        handleSubmit={updatedCodes => setParksoLocationId(updatedCodes)}
                    />
                </div>
            </div>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 align-self-start">
                    <div className='logo-container mt-1 mb-1'>{ imageUtilities.fetchPaymentProviderLogo(13) }</div>
                </div>
                <div className=" col-md-6 col-12">
                    <CashlessProviderCodesInput
                        allCodes={myCarPassLocationId}
                        handleSubmit={updatedCodes => setMyCarPassLocationId(updatedCodes)}
                    />
                </div>
            </div>
        </>
    )
}